module.exports = __webpack_public_path__ + "static/img/3.b08fb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3.png
// module id = CYQT
// module chunks = 84